<template>
  <div id="csvDsWrapper">
    <csv-datasource :dealer-id="dealer.id"></csv-datasource>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CsvDatasource from './CsvDatasource'
export default {
  components: {
    [CsvDatasource.name]: CsvDatasource
  },
  computed: {
    ...mapState('DealerStore', ['dealer'])
  }
}
</script>
